import {Drawer} from '@material-ui/core';
import {Button} from '@wandb/weave/components/Button';
import {Checkbox} from '@wandb/weave/components/Checkbox';
import React, {ChangeEvent} from 'react';

import {ResizableDrawer} from '../Launch/ResizableDrawer';
import * as S from './SecretsDrawer.styles';
// eslint-disable-next-line import/no-cycle -- please fix if you can
import {DrawerMode, PopupType} from './TeamSettingsSecrets';

type SecretsDrawerProps = {
  popupType: PopupType;
  drawerMode: DrawerMode;
  secretName: string;
  secretValue: string;
  showSecret: boolean;
  handleSecretValueChange: (val: string) => void;
  handleSecretNameChange: (name: string) => void;
  setShowSecret: (s: boolean) => void;
  inputError: boolean;
  buttonClickable: boolean;
  onClickAddSecret: () => void;
  onDrawerClose: () => void;
};

export const SecretsDrawer = ({
  popupType,
  drawerMode,
  secretName,
  secretValue,
  showSecret,
  handleSecretValueChange,
  handleSecretNameChange,
  setShowSecret,
  inputError,
  buttonClickable,
  onClickAddSecret,
  onDrawerClose,
}: SecretsDrawerProps) => {
  const isDrawerOpen = popupType === 'AddSecret';

  return (
    <Drawer anchor="right" open={isDrawerOpen} onClose={onDrawerClose}>
      <ResizableDrawer startWidth={600} minWidth={500}>
        <S.DrawerContents>
          <S.SecretsDrawer>
            <S.CenteredFlex>
              <S.Header>
                {drawerMode === 'Creating'
                  ? 'Create a new secret'
                  : 'Edit secret'}
              </S.Header>
              <S.CloseButton>
                <Button
                  icon="close"
                  size="large"
                  variant="ghost"
                  onClick={onDrawerClose}
                />
              </S.CloseButton>
            </S.CenteredFlex>
            <S.Divider />
            <S.SecretsDrawerMain>
              <S.LabelRow>
                <S.Label>Secret name</S.Label>
              </S.LabelRow>
              {/*The name field will only be enabled while creating secrets. They can't be edited using the EditSecret drawer.*/}
              <S.StyledTextField
                placeholder="Enter secret name"
                value={secretName ?? ''}
                onChange={handleSecretNameChange}
                disabled={drawerMode === 'Editing'}
              />
              {inputError && (
                <S.ErrorText>
                  Secret names can only contain alphanumeric characters ([a-z],
                  [A-Z], [0-9]) or underscores (_) and start with a letter
                  ([a-z], [A-Z]) or underscores (_).
                </S.ErrorText>
              )}
              <S.LabelRow>
                <S.Label>Secret</S.Label>
              </S.LabelRow>
              <S.StyledTextArea
                showSecret={showSecret}
                value={secretValue}
                placeholder="Enter secret value"
                onChange={(event: ChangeEvent<HTMLTextAreaElement>) =>
                  handleSecretValueChange(event.target.value)
                }
              />
              <S.CenteredFlex>
                <Checkbox
                  id="reveal-secret-checkbox"
                  checked={showSecret}
                  onCheckedChange={() => {
                    setShowSecret(!showSecret);
                  }}
                />
                <label htmlFor="reveal-secret-checkbox">Reveal secret</label>
              </S.CenteredFlex>
            </S.SecretsDrawerMain>
            <S.Divider />
            <S.Footer>
              <Button
                className="w-full"
                disabled={!buttonClickable}
                onClick={onClickAddSecret}>
                Add secret
              </Button>
            </S.Footer>
          </S.SecretsDrawer>
        </S.DrawerContents>
      </ResizableDrawer>
    </Drawer>
  );
};
